import api from "../services/api";
import { $Q } from "../utils/query-selector";

/**
 * It reads click event on logout button and empties the cart
 */
const readLogoutClick = () => {
  const logoutBtn = $Q('.orders-heading__link');

  if(!logoutBtn) return;

  logoutBtn.addEventListener('click', async(e) => {
    e.preventDefault();
    const anchorHref = logoutBtn.getAttribute('href');

    try {
      await api.emptyCart();
    } catch (error) {
      console.error(error);
    } finally {
      window.location.assign(anchorHref);
    }
  })
}

readLogoutClick();
